import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import BackButton from '../BackButton/BackButton';
import DayPickerRangeControllerWrapper from '../DayPickerRangeControllerWrapper/DayPickerRangeControllerWrapper';
// import { DayPickerRangeController } from 'react-dates';

import styles from './Calendar.module.css';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRoundTrip: true,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
    };
    this.toggleRoundTrip = this.toggleRoundTrip.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.clearForm = this.clearForm.bind(this);
  }

  // componentDidMount() {
  //   if (this.props.startDate || this.props.endDate) {
  //     let selectedDates = {
  //       startDate: this.props.startDate,
  //       endDate: this.props.endDate,
  //     }

  //     this.setState(selectedDates);
  //   }
  // }

  onDateChange(dates) {
    if (dates.startDate) {
      this.props.setStartDate(dates.startDate);
    }

    if (dates.endDate) {
      this.props.setEndDate(dates.endDate);
    }

    this.setState(dates);
  }

  toggleRoundTrip() {
    this.setState({
      startDate: null,
      endDate: null,
      isRoundTrip: !this.state.isRoundTrip
    });
  }

  clearForm() {
    console.log('clear');
    this.props.setEndDate(null);
    this.props.setStartDate(null);
    this.setState({ startDate: null, endDate: null });
  }

  render() {
    const { startDate, endDate, isRoundTrip } = this.state;
    const dayDiff = (startDate && endDate) ? endDate.diff(startDate, 'days') + 1 : 0;
    return (
      <div className={styles.calendar}>


        <div className={styles.header}>
          <div className={styles.controls}>
            <BackButton className={styles.back} />
            <Link to="#" className={styles.clear} onClick={this.clearForm}>Clear</Link>
          </div>
        </div>


        <div className={styles.roundTripSelectors}>
          <div onClick={this.toggleRoundTrip} className={this.state.isRoundTrip ? styles.selected : null} > Round trip </div>
          <div onClick={this.toggleRoundTrip} className={this.state.isRoundTrip ? null : styles.selected}> One way </div>
        </div>
        <div className={styles.calendarPicker}>
          <DayPickerRangeControllerWrapper
            // onOutsideClick={DayPickerRangeController.onOutsideClick}
            // onPrevMonthClick={DayPickerRangeController.onPrevMonthClick}
            // onNextMonthClick={DayPickerRangeController.onNextMonthClick}
            numberOfMonths={6}
            verticalHeight={800}
            endDateOffset={this.state.isRoundTrip ? null : 1}
            onDateChange={this.onDateChange}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
          />
        </div>
        <div className={styles.footer} >
          <h1>{ isRoundTrip ? `${dayDiff} DAYS` : 'One way' } </h1>
          <h2>{startDate ? startDate.format("MMM Do") : '-'} / {endDate ? `${endDate.format("MMM Do")}` : '-'}</h2>
          { this.props.startDate
            ? <Link to="/flights/outbound"> Show flights </Link>
            : null
          }
        </div>
      </div>
    );
  }
}

Calendar.propTypes = {
  startDate: propTypes.shape,
  endDate: propTypes.shape,
};

Calendar.defaultProps = {
  startDate: null,
  endDate: null,
};

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  startDate: main.startDate,
  endDate: main.endDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setStartDate: data =>
      dispatch({
        type: 'SET_STARTDATE',
        payload: data,
      }),
    setEndDate: data =>
      dispatch({
        type: 'SET_ENDDATE',
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.jsx